import Vue from 'vue';
import Router from 'vue-router';
import MainPage from '@/components/MainPage';

Vue.use(Router);

export default new Router({
  mode: 'history', // 注意这里的history必须要被单引号包裹起来,不然不会被识别
  // 修改路由高亮样式，默认值为'router-link-active'
  // linkActiveClass: 'active',
  routes: [
    {
      path: '/',
      name: 'MainPage',
      component: MainPage
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js